import constants from "../../commonUtils/constants";
import * as actionTypes from "./actionTypes";

const initialState = {
  loading: false,
  userData: null,
  filters: { keyword: "" },
  UsersList: { data: [], pagination: { currentPage: 1, perPage: constants.tableUI.defaultPerpage, total: 0 }},
  roles: [],
  errors: { name: "", email: "", password: "", role: "" },
  errorMessage: "",
};

const Users = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case actionTypes.SET_ERRORS:
      return {
        ...state,
        errors: action.payload,
      };
    case actionTypes.SET_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };
    case actionTypes.GET_USERS_SUCCESS:
      return {
          ...state,
          loading: false,
          UsersList: action.payload,
          // errors: { name: "", email: "", password: "", role: "" },
          // errorMessage: "",
      };
    case actionTypes.GET_USERS_FAILURE:
      return {
          ...state,
          loading: false,
          errors: action.payload.data,
          errorMessage: action.payload.message
      };
    case actionTypes.GET_USER_SUCCESS:
      return {
          ...state,
          loading: false,
          userData: action.payload,
          errors: { name: "", email: "", password: "", role: "" },
          errorMessage: ""
      };
    case actionTypes.GET_USER_FAILURE:
      return {
          ...state,
          loading: false,
          errors: action.payload.data,
          errorMessage: action.payload.message
      };
    case actionTypes.CREATE_USER_SUCCESS:
      return {
          ...state,
          loading: false,
          // UsersList: action.payload,
          // errors: { name: "", email: "", password: "", role: "" },
          // errorMessage: "",
      };
    case actionTypes.CREATE_USER_FAILURE:
      return {
          ...state,
          loading: false,
          errors: action.payload.data,
          errorMessage: action.payload.message
      };
    case actionTypes.UPDATE_USER_SUCCESS:
      return {
          ...state,
          loading: false,
          // UsersList: action.payload,
          // errors: { name: "", email: "", password: "", role: "" },
          // errorMessage: "",
      };
    case actionTypes.UPDATE_USER_FAILURE:
      return {
          ...state,
          loading: false,
          errors: action.payload.data,
          errorMessage: action.payload.message
      };
    case actionTypes.DELETE_USER_SUCCESS:
      return {
          ...state,
          loading: false,
          errorMessage: "",
      };
    case actionTypes.DELETE_USER_FAILURE:
      return {
          ...state,
          loading: false,
          errors: action.payload.data,
          errorMessage: action.payload.message
      };
    case actionTypes.UPDATE_USER_STATUS_SUCCESS:
      return {
          ...state,
          loading: false,
          errorMessage: "",
      };
    case actionTypes.UPDATE_USER_STATUS_FAILURE:
      return {
          ...state,
          loading: false,
          errors: action.payload.data,
          errorMessage: action.payload.message
      };
    case actionTypes.GET_USER_ROLES_SUCCESS:
      return {
          ...state,
          loading: false,
          roles: action.payload,
          // errors: { name: "", email: "", password: "", role: "" },
          // errorMessage: "",
      };
    case actionTypes.GET_USER_ROLES_FAILURE:
      return {
          ...state,
          loading: false,
          errors: action.payload.data,
          errorMessage: action.payload.message
      };
    default:
        return state;
  }
};

export default Users;
